import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { FiArrowRight } from 'react-icons/fi';
import styles from './styles.module.scss';
import { CatalogGroupIcon } from './catalog-group-icon';
import { resolveCatalogGroupParam } from './utils';
import { MethodBadge } from './method-badge';
import { ApiEndpoint, ApiGroup } from './types';

interface GroupsSectionProps {
    groups: ApiGroup[];
    allEndpoints: ApiEndpoint[];
}

/*
 * Grid of API group tiles on the Portal overview, each deep-linking to the Catalog
 * pre-filtered to that group.
 */
export function GroupsSection({ groups, allEndpoints }: GroupsSectionProps) {
    return (
        <div>
            <div className={styles.sectionHeading}>
                <h2>API Categories</h2>
                <Link to="/api-portal/catalog">
                    <Button>
                        View All APIs <FiArrowRight style={{ marginLeft: 6 }} />
                    </Button>
                </Link>
            </div>
            <div className={styles.tileGrid}>
                {groups.map((group) => {
                    const endpoints = group.endpoints ?? [];
                    const groupParam = resolveCatalogGroupParam(group, allEndpoints);
                    return (
                        <Link key={String(group.id)} to={`/api-portal/catalog?group=${encodeURIComponent(groupParam)}`}>
                            <div className={styles.cardHoverable}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div className={styles.iconTile}>
                                        <CatalogGroupIcon icon={group.icon} />
                                    </div>
                                    <div>
                                        <h4 style={{ margin: 0, color: '#fff', fontSize: 14 }}>{group.name}</h4>
                                        <span className={styles.mutedText} style={{ fontSize: 12 }}>
                                            {endpoints.length} {endpoints.length === 1 ? 'endpoint' : 'endpoints'}
                                        </span>
                                    </div>
                                </div>
                                <div className={styles.cardDivider} />
                                <p className={styles.mutedText} style={{ margin: 0 }}>
                                    {group.description}
                                </p>
                                {endpoints.length > 0 && (
                                    <>
                                        <div className={styles.cardDivider} />
                                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
                                            {endpoints.slice(0, 3).map((endpoint) => (
                                                <MethodBadge key={endpoint.id} method={endpoint.method} />
                                            ))}
                                            {endpoints.length > 3 && (
                                                <span className={styles.mutedText} style={{ fontSize: 12 }}>
                                                    +{endpoints.length - 3} more
                                                </span>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
